<template>
  <div class="dataTable__cell">
    <TextCellDataTableComponent
      v-if="item.type === dataTableConstante.TEXT_TYPE"
      :item="item.data"
      :column="columnName"
      :actions="item.actions"
      @emitRowAction="emitRowAction"
    />
    <ListTextCellDataTableComponent
      v-if="item.type === dataTableConstante.LIST_TEXT_TYPE"
      :list="item.data"
      :column="columnName"
      :actions="item.actions"
      @emitRowAction="emitRowAction"
    />
    <DateCellDataTableComponent
      v-if="item.type === dataTableConstante.DATE_TYPE"
      :column="columnName"
      :item="item.data"
    />
    <StatusCellDataTableComponent
      v-if="item.type === dataTableConstante.STATUS_TYPE"
      :item="item.data"
      :column="columnName"
    />
    <DocumentCellDataTableComponent
      v-if="item.type === dataTableConstante.DOCUMENTS_TYPE"
      :item="item.data"
      :column="columnName"
    />
    <ListDocumentCellDataTableComponent
      v-if="item.type === dataTableConstante.LIST_DOCUMENTS_TYPE"
      :list="item.data"
      :column="columnName"
    />
  </div>
</template>

<script>
import { dataTableConstante } from "@/constantes/data-table";
import TextCellDataTableComponent from "@/components/data-table/cell/TextCellDataTableComponent.vue";
import ListTextCellDataTableComponent from "@/components/data-table/list-cell/ListTextCellDataTableComponent.vue";
import DateCellDataTableComponent from "@/components/data-table/cell/DateCellDataTableComponent.vue";
import StatusCellDataTableComponent from "@/components/data-table/cell/StatusCellDataTableComponent.vue";
import DocumentCellDataTableComponent from "@/components/data-table/cell/DocumentCellDataTableComponent.vue";
import ListDocumentCellDataTableComponent from "@/components/data-table/list-cell/ListDocumentCellDataTableComponent.vue";

export default {
  name: "CellDataTableComponent",
  components: {
    ListDocumentCellDataTableComponent,
    DocumentCellDataTableComponent,
    StatusCellDataTableComponent,
    DateCellDataTableComponent,
    ListTextCellDataTableComponent,
    TextCellDataTableComponent,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
  },

  emits: ["emitRowAction"],
  computed: {
    dataTableConstante() {
      return dataTableConstante;
    },
    columnName() {
      if (this.columns && this.columns[this.item.name] && this.columns[this.item.name].title) {
        return this.columns[this.item.name].title;
      } else return "";
    },
  },
  methods: {
    emitRowAction(payload) {
      this.$emit("emitRowAction", payload);
    },
  },
};
</script>

<style lang="scss" scoped></style>
